import React from 'react';
import logo from "../assets/logo/logo.png";
import { useLocation, useNavigate, Link } from "react-router-dom";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const location = useLocation();
    const navigate = useNavigate();

    const handleNavigation = (e, targetId) => {
        e.preventDefault();

        // If it's the "Home" button specifically
        if (targetId === "/") {
            if (location.pathname === "/") {
                scrollToTop();
            } else {
                navigate("/");
            }
            return;
        }

        if (location.pathname === "/") {
            // Case 1: Already on Home - Direct Smooth Scroll
            const element = document.getElementById(targetId.replace("#", ""));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            }
        } else {
            // Case 2: On subpage - Navigate to Home with Hash
            // navigate("/#about")
            navigate(`/${targetId}`);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <footer className="w-full bg-background-light dark:bg-background-dark pt-24 pb-12 border-t border-gray-200 dark:border-gray-800 transition-colors duration-300 overflow-hidden">
            <div className="w-[90%] mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-20">

                    {/* Brand & Socials */}
                    <div className="reveal lg:col-span-4 space-y-8">
                        <Link to="/" className="flex items-center gap-4 text-gray-900 dark:text-white group" onClick={(e) => { e.preventDefault(); scrollToTop(); }}>
                            <div className="size-12 rounded-[50%] bg-primary text-white flex items-center justify-center transform group-hover:rotate-[15deg] transition-all duration-500 shadow-glow">
                                <img src={logo} alt="logo" />
                            </div>
                            <span className="text-3xl font-display font-bold tracking-tighter">
                                Rahul<span className="text-primary">.Biswas</span>
                            </span>
                        </Link>
                        <p className="text-lg text-gray-600 dark:text-text-secondary leading-relaxed max-w-md">
                            Building digital experiences that bridge the gap between complex code and human emotion. Founder
                            of <span className="text-primary font-semibold">Eventix</span> and lead developer at <span className="text-primary font-semibold">ContactHQ</span>.
                        </p>

                        <div className="flex items-center gap-4">
                            {/* LinkedIn */}
                            <a
                                href="https://www.linkedin.com/in/rahulbiswas0675/"
                                target="_blank"
                                rel="noopener noreferrer"
                                // Changed: bg-primary, text-white. Hover now changes background to brand color.
                                className="size-12 rounded-xl flex items-center justify-center text-white bg-primary hover:bg-[#0077b5] transition-all shadow-soft hover:shadow-md hover:scale-105 group"
                                title="LinkedIn"
                            >
                                <svg className="w-5 h-5 fill-current transition-transform" viewBox="0 0 24 24">
                                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                                </svg>
                            </a>

                            {/* GitHub */}
                            <a
                                href="https://github.com/rahulbiswas"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="size-12 rounded-xl flex items-center justify-center text-white bg-primary hover:bg-[#2dba4e] transition-all shadow-soft hover:shadow-md hover:scale-105 group"
                                title="GitHub"
                            >
                                <svg className="w-5 h-5 fill-current transition-transform" viewBox="0 0 24 24">
                                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                                </svg>
                            </a>

                            {/* Instagram */}
                            <a
                                href="https://www.instagram.com/rahul.lens.ig/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="size-12 rounded-xl flex items-center justify-center text-white bg-primary hover:bg-[#e1306c] transition-all shadow-soft hover:shadow-md hover:scale-105 group"
                                title="Instagram"
                            >
                                <svg className="w-5 h-5 fill-current transition-transform" viewBox="0 0 24 24">
                                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                </svg>
                            </a>

                            {/* X (Twitter) */}
                            <a
                                href="https://x.com/RahulBiswas0675"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="size-12 rounded-xl flex items-center justify-center text-white bg-primary hover:bg-gray-900 transition-all shadow-soft hover:shadow-md hover:scale-105 group"
                                title="X (Twitter)"
                            >
                                <svg className="w-4 h-4 fill-current transition-transform" viewBox="0 0 24 24">
                                    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.932zm-1.294 19.497h2.039L6.486 3.24H4.298l13.309 17.41z" />
                                </svg>
                            </a>

                            {/* YouTube */}
                            <a
                                href="https://www.youtube.com/@B4_I_Sleep"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="size-12 rounded-xl flex items-center justify-center text-white bg-primary hover:bg-[#ff0000] transition-all shadow-soft hover:shadow-md hover:scale-105 group"
                                title="YouTube"
                            >
                                <svg className="w-5 h-5 fill-current transition-transform" viewBox="0 0 24 24">
                                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                </svg>
                            </a>

                            {/* Facebook */}
                            <a
                                href="https://www.facebook.com/rahulbiswas0675"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="size-12 rounded-xl flex items-center justify-center text-white bg-primary hover:bg-[#1877f2] transition-all shadow-soft hover:shadow-md hover:scale-105 group"
                                title="Facebook"
                            >
                                <svg className="w-5 h-5 fill-current transition-transform" viewBox="0 0 24 24">
                                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                </svg>
                            </a>
                        </div>
                    </div>

                    {/* Ecosystem Links */}
                    <div className="reveal reveal-delay-1 lg:col-span-2">
                        <h4 className="text-sm font-bold uppercase tracking-widest text-gray-400 dark:text-gray-500 mb-6 font-display">
                            Ecosystem
                        </h4>
                        <ul className="flex flex-col -ml-3">
                            <li><button onClick={(e) => handleNavigation(e, "/")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors">Home</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#about")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">About</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#experience")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Journey</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#projects")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Works</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#articles")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Articles</button></li>
                        </ul>
                    </div>

                    {/* Focus Links */}
                    <div className="reveal reveal-delay-2 lg:col-span-2">
                        <h4 className="text-sm font-bold uppercase tracking-widest text-gray-400 dark:text-gray-500 mb-6 font-display">
                            Focus
                        </h4>
                        <ul className="flex flex-col -ml-3">
                            <li><button onClick={(e) => handleNavigation(e, "#skills")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Skills</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#education")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Education</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#hobbies")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Hobbies</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#gallery")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Gallery</button></li>
                            <li><button onClick={(e) => handleNavigation(e, "#reviews")} className="px-3 py-2 text-sm font-medium text-gray-600 dark:text-text-secondary hover:text-primary transition-colors text-left">Reviews</button></li>
                        </ul>
                    </div>

                    {/* Availability Card */}
                    <div className="reveal reveal-delay-3 lg:col-span-4">
                        <div className="relative p-8 rounded-3xl bg-white dark:bg-surface-dark border border-gray-200 dark:border-gray-800 shadow-soft overflow-hidden group">
                            <div className="absolute -right-4 -top-4 size-32 bg-primary/5 rounded-full blur-3xl group-hover:bg-primary/10 transition-colors"></div>

                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-widest font-display mb-6">
                                <span className="relative flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                                </span>
                                Available Now
                            </div>

                            <h4 className="text-2xl font-display font-bold text-gray-900 dark:text-white mb-4 tracking-tight">
                                Let's build something.
                            </h4>
                            <p className="text-gray-600 dark:text-text-secondary mb-8 text-sm leading-relaxed">
                                Currently open to selective freelance opportunities and SaaS collaborations.
                            </p>

                            <button onClick={(e) => handleNavigation(e, "#contact")} className="flex items-center justify-center gap-2 w-full py-4 bg-primary text-white text-sm font-bold rounded-2xl hover:bg-primary-dark transition-all shadow-lg shadow-primary/20 group/btn">
                                <span>Start a Conversation</span>
                                <span className="material-symbols-outlined text-sm group-hover/btn:translate-x-1 transition-transform">arrow_forward</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="reveal reveal-delay-4 pt-10 border-t border-gray-200 dark:border-gray-800 flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="text-sm text-gray-500 dark:text-gray-400 text-center md:text-left">
                        <p>© <span>{currentYear}</span> Rahul Biswas. All rights reserved.</p>
                        <p className="mt-1 font-mono text-[10px] uppercase tracking-tighter opacity-50">
                            Crafted with precision & passion
                        </p>
                    </div>

                    <div className="flex items-center gap-8">
                        <a href="https://contacthq.in" target='_blank' className="text-xs font-bold text-gray-400 hover:text-primary transition-colors uppercase tracking-widest">
                            ContactHQ
                        </a>
                        <a href="http://eventix.in/" target='_blank' className="text-xs font-bold text-gray-400 hover:text-primary transition-colors uppercase tracking-widest">
                            Eventix
                        </a>
                        <button
                            onClick={scrollToTop}
                            className="size-12 rounded-2xl border border-gray-200 dark:border-gray-800 flex items-center justify-center text-gray-500 hover:bg-primary hover:text-white hover:border-primary transition-all shadow-soft group"
                        >
                            <span className="material-symbols-outlined group-hover:-translate-y-1 transition-transform">arrow_upward</span>
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;